import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

class HomeDispatcher extends Component {
  constructor(props) {
    super(props);

    this.state = {
      homeDir: undefined,
    };
  }

  componentDidMount() {
    const role = this.props.userInfo.role;
    switch (role) {
      case 'SuperAdmin':
        if (window.location.hostname === 'localhost') {
          this.setState({ homeDir: '/dm/home' });
        } else {
          this.setState({ homeDir: '/sa/home' });
        }
        break;
      case 'AllevaRep':
        this.setState({ homeDir: '/ar/home' });
        break;
      case 'Admin':
      case 'User':
        this.setState({ homeDir: '/u/home' });
        break;
      default:
        this.setState({ homeDir: '/p/home' });
        break;
    }
  }

  render() {
    if (this.state.homeDir) {
      return <Redirect to={this.state.homeDir} />;
    } else {
      return <h3>Waiting to know where to redirect to</h3>;
    }
  }
}

const mapStateToProps = (state) => ({ userInfo: state.userInfo });
export default connect(mapStateToProps)(HomeDispatcher);
